import { NgModule } from '@angular/core';
import { ErrorComponent } from '@fc-core/form-utils/form-error/error.component';
import { FormFieldComponent } from './form-field/form-field.component';
import { HintComponent } from './hint/hint.component';
import { InputDirective } from './input.directive';
import { LabelComponent } from './label/label.component';
import { PrefixDirective } from './prefix.directive';
import { SuffixDirective } from './suffix.directive';

const CORE_INPUT_PIECES = [
  FormFieldComponent,
  LabelComponent,
  InputDirective,
  PrefixDirective,
  SuffixDirective,
  ErrorComponent,
  HintComponent,
];

@NgModule({
  imports: CORE_INPUT_PIECES,
  exports: CORE_INPUT_PIECES,
})
export class CoreInputModule {}
